/**
 * 参数处理
 * @param {*} params  参数
 */

import { setStorage, getStorage } from "@/utils";

export function tansParams(params: { [x: string]: any }) {
  let result = "";
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    const part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof value !== "undefined") {
      if (typeof value === "object") {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== "" && typeof value[key] !== "undefined") {
            const params = propName + "[" + key + "]";
            const subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result;
}

/** 排队执行promise **/

export const queuePromise = (proms: any) => {
  let res: any = undefined,
    rej: any = undefined;
  const pro = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });

  const result: any[] = [];
  let count = 0;
  let fullfilledCount = 0;
  for (const prom of proms) {
    const i = count;
    count++;
    Promise.resolve(prom).then((data) => {
      result[i] = data;
      fullfilledCount++;
      if (fullfilledCount === count) {
        res({ result, count, fullfilledCount });
      }
    }, rej);
  }
  if (count === 0) {
    res({ result: [], count, fullfilledCount });
  }

  return pro;
};

export const loadImage = (url: unknown) => {
  return new Promise((resolve, reject) => {
    const image: any = new Image();
    image.onload = async () => {
      resolve({
        width: image.width,
        height: image.height,
        src: image.currentSrc,
        image: image
      });
    };
    image.onerror = reject;
    image.src = url;
  });
};

const base64ConvertFile = function (urlData: string, filename = "filename") {
  const arr: any = urlData.split(",");
  const type = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: type
  });
};

export const loadReader = (file: Blob) => {
  return new Promise((resolve, reject) => {
    if (window.FileReader) {
      const read = new FileReader();
      read.readAsDataURL(file);

      read.onload = ({ target }: any) => {
        resolve(target.result);
      };
      read.onerror = reject;
    }
  });
};

/** 压缩图片 **/

export const compress = (file: { size: number; raw: File; name: string; image: string }, size = 1024 * 1024 * 10, quality = 0.8, width: any = 1080) => {
  return new Promise((resolve, reject) => {
    try {
      if (file.size > size) {
        console.log("开始压缩文件");
        loadReader(file.raw).then((result) => {
          loadImage(result)
            .then((img: any) => {
              const canvas = document.createElement("canvas");

              const ctx: any = canvas.getContext("2d");
              if (img.width > width) {
                const radio: any = Number((width / img.width).toFixed(2));

                const height: any = img.height * radio.toFixed(1);
                canvas.setAttribute("width", width);
                canvas.setAttribute("height", height);
                ctx.drawImage(img.image, 0, 0, width, height);
                const base64 = canvas.toDataURL(file.raw.type, 1);
                file.raw = base64ConvertFile(base64, file.name);
                file.size = file.raw.size;
                file.image = base64;
                resolve(file);
                return;
              } else {
                canvas.setAttribute("width", img.width);
                canvas.setAttribute("height", img.width);
                ctx.drawImage(img.image, 0, 0, img.width, img.width);
                const base64 = canvas.toDataURL(file.raw.type, quality);
                file.raw = base64ConvertFile(base64, file.name);
                file.size = file.raw.size;
                file.image = base64;
                resolve(file);
                return;
              }
            })
            .catch((error) => {
              console.log("eeeee", error);
              reject(error);
            });
        });
      } else {
        loadReader(file.raw).then((result: any) => {
          file.image = result;
          resolve(file);
          return;
        });
      }
    } catch (error) {
      reject(error);
    }
  });
};

// 跟据当前监控主机判断进入哪个监控主机的项目

export const linkToPoint = () => {
  const mobileEquipment = /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile|kfapwi|playbook/i;
  const port = window.location.port || location.port;
  const protocol = window.location.protocol || location.protocol;
  const userAgent = window.navigator.userAgent;
  const mobile = window.VITE_APP_MOBILE_PORT || import.meta.env.VITE_APP_MOBILE_PORT;
  const pc = window.VITE_APP_PC_PORT || import.meta.env.VITE_APP_PC_PORT;
  const mobileLocation = window.location.protocol + "//" + window.location.hostname + ":" + (window.VITE_APP_MOBILE_PORT || import.meta.env.VITE_APP_MOBILE_PORT);
  const pcLocation = window.location.protocol + "//" + window.location.hostname + ":" + (window.VITE_APP_PC_PORT || import.meta.env.VITE_APP_PC_PORT);
  const equip = getStorage("equip"); //1:移动端  2:PC端

  if (userAgent) {
    if (mobileEquipment.test(userAgent.toLowerCase())) {
      if (port) {
        if (port != mobile) {
          location.assign(mobileLocation);
        }
      } else {
        if (equip != "1") {
          setStorage("equip", 1);
          location.assign(mobileLocation);
        }
      }
    } else {
      if (port) {
        if (port != pc) {
          location.assign(pcLocation);
        }
      } else {
        if (equip != "2") {
          setStorage("equip", 2);
          location.assign(pcLocation);
        }
      }
    }
  } else {
    if (port) {
      if (port != mobile) {
        location.assign(mobileLocation);
      }
    } else {
      if (protocol === "https:" && equip != "1") {
        setStorage("equip", 1);
        location.assign(mobileLocation);
      } else if (protocol === "http:" && equip != "2") {
        setStorage("equip", 2);
        location.assign(pcLocation);
      }
    }
  }
};
